/* global $ u ko */
function init (refer) {
  // collection.load()
  let vm = {
    // data: ko.observable('tttg')
    // data: ko.observable({
    //   title: '1',
    //   materiel: '2',
    //   time: '3',
    //   state: '4'
    // })
    data: ko.observableArray([
      {
        title: '1',
        materiel: '2',
        time: '3',
        state: '4'
      }
    ])
  }
  let app = u.createApp()
  app.init(vm, $('#gridrefer')[0])
  refer.registerSubmitFunc(() => {
    return vm.data()
  })
}
let template = require('./index.html')
export default {
  init,
  template
}



// WEBPACK FOOTER //
// ./src/components/modalrefer/grid/index.js